import React from 'react';
import CreateAccountForm from '../../Accounts/AccountMgmt/CreateAccountForm';

export default function AccountCreatePage(props) {
	console.log('Account Create Page', props);
	return (
		<div>
			<CreateAccountForm iam_account_create_endpoint={props.iam_account_create_endpoint} />
		</div>
	);
}
